
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        enabled: {
            type: Boolean,
            default: false,
        },
    },
})
